<template>
    <div>
        {{label}}
        <ul class="list-gruop">
            <li v-for="(image, index) in images" class="list-group-item">
                <div class="gallery-image-preview" :style="`background-image: url(${image.url})`"> </div>
                <a href @click.prevent="removeImage(index)" class="pull-right">
                    <i class="fa fa-times"></i>
                </a>
            </li>
        </ul>
        <div class="photo-upload" :class="disabled ? 'disabled' : 'enabled'">
            <div class="gallery-uploader" :class="{'hovering': hovering, 'gallery-uploader-busy': busy}" ref="uploader">
                <template v-if="busy">
                    Uploading...
                    <i class="fas fa-circle-notch fa-spin"></i>
                </template>
                <template v-else>
                    <ul class="gallery-images">
                        <li v-for="(preview, index) in previews" class="gallery-image" :style="`background-image: url(${preview})`">
                            <a href @click.prevent.stop="removeFile(index)" class="pull-right">
                                <i class="fa fa-times"></i>
                            </a>
                        </li>
                    </ul>
                    <span v-show="previews.length === 0" class="upload-instructions">
                        <slot>
                            Click or drag
                            <br> image here
                            <br> to upload...
                        </slot>
                    </span>
                    <input class="file-photo" multiple type="file" accept="image/*" capture @change="handleImage" @dragenter="hovering = true" @dragleave="hovering = false" :disabled="disabled" />
                </template>
            </div>
        </div>
    </div>
</template>

<style>
.gallery-uploader {
    position: relative;
    overflow: hidden;
    width: 100%;
    height: 250px;
    background-color: #f3f3f3;
    background-size: contain;
    background-position: center center;
    background-repeat: no-repeat;
    border: 2px dashed #e8e8e8;
    display: inline-block;
}

.enabled .gallery-uploader.hovering {
    background-color: #bbb;
}

.enabled .gallery-uploader:hover {
    background-color: skyblue;
}

.gallery-images {
    list-style-type: none;
    padding: 0;
    text-align: center;
    position: absolute;
    left: 0;
    left: 50%;
    top: 50%;
    -webkit-transform: translateY(-50%);
    transform: translate(-50%, -50%);
    z-index: 1;
}

.gallery-image,
.gallery-image-preview {
    width: 80px;
    height: 60px;
    margin: 8px;
    background-size: contain;
    background-position: center center;
    display: inline-block;
}

.upload-instructions {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translateX(-50%) translateY(-50%);
    text-align: center;
}

.file-photo {
    position: absolute;
    width: 100%;
    height: 400px;
    top: -50px;
    left: 0;
    z-index: 0;
    opacity: 0;
}

.enabled .file-photo {
    cursor: pointer;
}
.list-group-item{
    display: inline-block;
    margin-right:10px;
    margin-bottom:10px;
}
</style>

<script>
export default {
    props: {
        value: true,
        busy: {type: Number, default: 0},
        disabled: {type: Boolean, default: false},
        disablePreview: {type: Boolean, default: false},
        label: {type: String, default: 'Gallery'}
    },
    methods: {
        handleImage(event) {
            if (this.disabled) {
                return;
            }
            let files = event.target.files;
            if (files.length === 0) {
                return;
            }

            const allFiles = Array.from(files);
            if (!this.disablePreview) {
                allFiles.forEach(file => {
                    this.files.push(file);
                    let reader = new FileReader();
                    reader.onload = (event) => {
                        this.previews.push(event.target.result);
                    };
                    reader.readAsDataURL(file);
                });
            }

            this.$emit('change', allFiles);
        },
        removeFile(index) {
            this.previews.splice(index, 1);
            this.files.splice(index, 1);
        },
        removeImage(index) {
            this.images[index].remove = !this.images[index].remove;
            this.$emit('input', this.images.filter(x => !x.remove));
        },
        loadImages() {
            this.files = [];
            this.previews = [];
            if (!this.value) {
                return this.images = [];
            }
            this.images = this.value.map(x => {
                x.remove = false;
                return x;
            });
        }
    },
    data() {
        return {
            hovering: false,
            previews: [],
            images: [],
            files: []
        };
    },
    watch: {
        value: {
            handler: 'loadImages',
            immediate: true
        }
    }
};
</script>


// WEBPACK FOOTER //
// resources/js/ui/GalleryUpload.vue